import type {
    IConsumable,
    IMigrationStatus,
} from '@experiences/interfaces';

import type {
    ILicenseAndKey,
    IRobotAndServicesLicenses,
} from '../../../common/interfaces/licenses';
import store from '../../../store';
import { setUserProfile } from '../../../store/action/UserProfileAction';
import { get } from '../../utility/Requests';

export const licenseManagementAccountUrl = '/api/license/management/account';
export const licenseManagementAccountConsumablesUrl = '/api/license/management/account/consumables';
export const licenseManagementAccountFreeConsumablesOrganizationUrl = '/api/license/management/account/free-consumables/organization';
export const licenseManagementAccountFreeConsumablesUserUrl = '/api/license/management/account/free-consumables/user';
export const licenseManagementMigrationStatusUrl = '/api/license/management/account/migration-status';

export function getRobotsAndServices({
    accountUserId, accountGlobalId,
}: { url: string; accountUserId: string; accountGlobalId: string }) {
    return get<IRobotAndServicesLicenses>(`${licenseManagementAccountUrl}/available`, {
        urlParams: {
            accountUserId,
            accountGlobalId,
        },
    });
}

export async function fetchAccountLicenseWithMlKeysAndUpdateAccountType() {
    const profileState = store.getState().profile;
    const accountUserId = profileState.userGlobalId;
    const accountGlobalId = profileState.accountUserDto.accountGlobalId.toLowerCase();
    const accountType = profileState.accountUserDto.accountType;

    const result = await get<ILicenseAndKey>(licenseManagementAccountUrl, {
        urlParams: {
            accountUserId,
            accountGlobalId,
        },
    });

    // Sets the accountType, and the subscription code behind it, based on the value in LRM
    const lrmAccountType = result?.accountLicense?.accountType;
    const lrmSubscriptionCode = result?.accountLicense?.subscriptionCode;
    if (lrmAccountType && (lrmAccountType !== accountType || lrmSubscriptionCode !== profileState.accountUserDto.subscriptionCode)) {
        setUserProfile({
            ...profileState,
            accountUserDto: {
                ...profileState.accountUserDto,
                accountType: lrmAccountType,
                subscriptionCode: lrmSubscriptionCode,
            },
        });
    }

    return result;
}

export async function getConsumables({
    accountGlobalId, includeTrialConsumables,
}: { url: string; accountGlobalId: string; tenantGlobalId?: string; includeTrialConsumables?: boolean }) {
    const queryParams: { [key: string]: any } = {
        accountGlobalId,
        includeTrialConsumables,
    };
    return await get<IConsumable[]>(licenseManagementAccountConsumablesUrl, { urlParams: queryParams });
}

export async function getFreeConsumablesOrganization({ url }: { url: string; accountGlobalId: string }) {
    return await get<IConsumable[]>(licenseManagementAccountFreeConsumablesOrganizationUrl);
}

export async function getFreeConsumablesUser({ url }: { url: string; accountGlobalId: string }) {
    return await get<IConsumable[]>(licenseManagementAccountFreeConsumablesUserUrl);
}

export async function getMigrationStatus(licenseCode: string) {
    const url = `${licenseManagementMigrationStatusUrl}/${encodeURIComponent(licenseCode)}`;
    return await get<IMigrationStatus>(url);
}
